import * as go from 'gojs/release/go-module';

export class ExtendedNode extends go.Node {
  private _skipsLayoutCommit = false;

  /**
   * Gets or sets whether this part should be positioned during a layout.
   * The initial and normal value is false.
   *
   * This differs from #isLayoutPositioned in that setting this value to `true`
   * allows this part to still be considered in determining the layout of other
   * parts, but this part itself will not be not repositioned.
   */
  get skipsLayoutCommit() {
    return this._skipsLayoutCommit;
  }

  set skipsLayoutCommit(value: boolean) {
    this._skipsLayoutCommit = value;
  }

  cloneProtected(copy: this) {
    super.cloneProtected(copy);
    // eslint-disable-next-line no-param-reassign
    copy.skipsLayoutCommit = this.skipsLayoutCommit;
  }
}
